'use client';

import { Link } from 'react-transition-progress/next';
import { Divider } from './common/divider';
import { AuthLinksForGuest } from '@/components/layout/pc/left-navigation/auth-links-for-guest';
import { AuthenticatedNavigation } from '@/components/layout/pc/left-navigation/authenticated-navigation';
import { CopyRight } from '@/components/layout/pc/left-navigation/common/copy-right';
import { Official } from '@/components/layout/pc/left-navigation/common/official';
import { Support } from '@/components/layout/pc/left-navigation/common/support';
import { IconLogo } from '@/components/ui/icons/IconLogo';
import { PATHS } from '@/constants/path';
import { usePathname } from '@/i18n/routing';
import { useAuthenticationContext } from '@/providers/auth-provider';

export const LeftNavigation = () => {
  const { isRegistered } = useAuthenticationContext();

  const pathname = usePathname();
  return (
    <div className='sticky top-0 hidden h-screen w-[20rem] flex-col justify-between overflow-auto bg-kl-dark px-4 py-6 lg:flex'>
      <div>
        <Link href={PATHS.ROOT} className='block pb-5 pl-1'>
          <IconLogo color='white' width={120} height={22} />
        </Link>
        <Divider />
        {isRegistered ? <AuthenticatedNavigation currentPath={pathname} /> : <AuthLinksForGuest />}
        <Divider />
        <Support />
        <Divider />
        <Official />
        <CopyRight />
      </div>
    </div>
  );
};
